import bowser from 'bowser';
import merge from 'lodash/merge';
import { checkWebGl } from './checkWebGl';

const browser = bowser.getParser(window.navigator.userAgent);

const browserSpecs = browser.getResult();

const isIos = browser.isOS('iOS');

const isSafari = browser.isBrowser('safari') || browser.isBrowser('Safari');

const isIphone =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Generated using standard query
// See: https://browserslist.dev/?q=PiAwLjUlLCBsYXN0IDIgdmVyc2lvbnMsIEZpcmVmb3ggRVNSLCBub3QgZGVhZCwgbm90IElFIDktMTE%3D
// See: https://pushstart.atlassian.net/wiki/spaces/KPROD/pages/4369973337/Requisitos+-+M+nimos+e+Recomendados
const isInvalidBrowser = !browser.satisfies({
  chrome: '>101',
  firefox: '>101',
  edge: '>102',

  opera: '>85',

  samsung_internet: '>16.0',
  safari: '>15.4',
});

const webgl = checkWebGl();

export const useBrowserSpecs = () => {
  return merge(browserSpecs, {
    isIos,
    isSafari,
    isIphone,
    isInvalidBrowser,
    webgl,
  });
};
